var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',{attrs:{"label":_vm.label,"accept":".xlsx, .xls","prepend-icon":"mdi-file-excel-box","outlined":"","hide-details":"","dense":""},on:{"click:clear":_vm.handleClear,"change":_vm.handleClick},model:{value:(_vm.fileUpload),callback:function ($$v) {_vm.fileUpload=$$v},expression:"fileUpload"}})
}
var staticRenderFns = []

export { render, staticRenderFns }